import { clearIdentity } from 'modules/identity';
import { clearPolicy } from 'modules/policy';
import { SETTINGS_MODE } from 'shared/enums';

export const clearNavigationActions = {
  [SETTINGS_MODE.users]: clearIdentity,
  [SETTINGS_MODE.policies]: clearPolicy,
};
